/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EnterpriseCustomerIdDto } from './enterpriseCustomerIdDto';
import { LocationIdDto } from './locationIdDto';
import { FieldIdDto } from './fieldIdDto';

export interface GeometryIdDto {
  active?: boolean;
  area?: number;
  customer?: EnterpriseCustomerIdDto;
  deleted?: boolean;
  field?: FieldIdDto;
  id?: number;
  location?: LocationIdDto;
  name?: string;
}
